"use client";

import { useAriaAnnouncerStore } from "@/stores/ariaAnnouncerStore";
import styles from "./styles.module.scss";
import { Box as MantineBox } from "@mantine/core";

/**
 * AriaAnnouncer - Invisible component that announces dynamic updates to screen readers
 *
 * This component renders ARIA live regions that are visually hidden but read by screen readers.
 * Use this for non-critical updates that don't warrant a visual notification:
 * - Adding/removing favorites
 * - Filter changes
 * - Loading more items
 * - Search results updates
 *
 * For critical errors or important alerts, use Mantine Notifications instead.
 */
const AriaAnnouncer = () => {
  const message = useAriaAnnouncerStore((state) => state.message);
  const priority = useAriaAnnouncerStore((state) => state.priority);

  return (
    <>
      {/* Polite announcements - waits for user to pause */}
      <MantineBox role="status" aria-live="polite" aria-atomic="true" className={styles.srOnly}>
        {priority === "polite" ? message : ""}
      </MantineBox>

      {/* Assertive announcements - interrupts immediately (use sparingly) */}
      <MantineBox role="alert" aria-live="assertive" aria-atomic="true" className={styles.srOnly}>
        {priority === "assertive" ? message : ""}
      </MantineBox>
    </>
  );
};

export default AriaAnnouncer;
